import { createUseStyles } from "react-jss";
import {
  NB_SECOND_SHOW_LEVEL,
  NB_SECOND_SHOW_NEXT_LEVEL,
} from "../../../constants/animation";
import { ITheme } from "../../../store/slices/theme";

export const useStyles = () => {
  const rankBadge = document.getElementById("rank-badge");
  const rankBadgeElemRect = rankBadge?.getBoundingClientRect();
  const offsetLeft = rankBadgeElemRect?.left || 0;
  const offsetTop = rankBadgeElemRect?.top || 0;

  return createUseStyles((theme: ITheme) => ({
    root: {
      position: "fixed",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      zIndex: theme.zIndex.dialog + 2,
      background: theme.colors.BackgroundBackdrop,
    },
    hideRoot: {
      animation: `$hide 0.5s forwards`,
    },
    autoHideRoot: {
      animation: `$hide 0.5s 2.5s forwards`,
    },
    main: {
      display: "flex",
      position: "absolute",
      width: "100%",
      height: "100%",
      zIndex: theme.zIndex.normal,
    },
    content: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      flexDirection: "column",
      width: "100%",
      position: "relative",
    },
    title: {
      textAlign: "center",
      position: "absolute",
      transform: "translateY(-50%)",
      top: "30%",
      "@media (orientation: landscape)": {
        top: "20%",
      },
    },
    level: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      position: "relative",
    },
    confetti: {
      position: "absolute",
      bottom: theme.spacing.space48 + theme.spacing.space16,
    },
    labelOutSide: {
      position: "absolute",
      bottom: theme.spacing.space48,
      textAlign: "center",
      width: "100%",
      "@media (orientation: landscape)": {
        bottom: theme.spacing.space20,
      },
    },
    rankName: {
      position: "absolute",
      transform: "translateY(-50%)",
      top: "60%",
      textAlign: "center",
      textTransform: "capitalize",
      "@media (orientation: landscape)": {
        top: "70%",
      },
    },
    hideRankName: {
      opacity: 1,
      animation: `$hide 1s 0.5s forwards`,
    },
    showRankName: {
      opacity: 0,
      animation: `$show 1s 0.5s forwards`,
    },
    rank: {
      position: "fixed",
      zIndex: theme.zIndex.normal + 1,
      top: offsetTop,
      left: offsetLeft,
      animation: `$scaleRank 1s cubic-bezier(0.25, 0.46, 0.45, 0.94) forwards`,
    },
    hideOld: {
      transform: "scale(3.5)",
      top: "calc(50% - 30px)",
      left: "calc(50% - 20px)",
      animation: `$hideBadge ${NB_SECOND_SHOW_LEVEL}s 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94) forwards`,
    },
    nextRank: {
      position: "fixed",
      zIndex: theme.zIndex.normal + 1,
      top: "calc(50% - 30px)",
      left: "calc(50% - 20px)",
      transform: "scale(3)",
      opacity: 0,
    },
    showNext: {
      animation: `$showBadge ease-out ${NB_SECOND_SHOW_NEXT_LEVEL}s 0.5s forwards`,
    },

    "@keyframes show": {
      "0%": {
        opacity: 0,
      },
      "100%": {
        opacity: 1,
      },
    },
    "@keyframes hide": {
      "0%": {
        opacity: 1,
        pointerEvents: "visible",
      },
      "100%": {
        opacity: 0,
        pointerEvents: "none",
      },
    },
    "@keyframes hideBadge": {
      "0%": {
        opacity: 1,
      },
      "100%": {
        opacity: 0,
      },
    },
    "@keyframes showBadge": {
      "0%": {
        opacity: 0,
        transform: "scale(3)",
      },
      "40%": {
        opacity: 1,
        transform: "scale(5)",
      },
      "60%": {
        opacity: 1,
        transform: "scale(2.5)",
      },
      "70%": {
        opacity: 1,
        transform: "scale(4)",
      },
      "90%": {
        opacity: 1,
        transform: "scale(3)",
      },
      "100%": {
        opacity: 1,
        transform: "scale(3.5)",
      },
    },
  }))();
};
